export default __webpack_public_path__ + "static/media/nicoluna.06477e72.png";